import { render, staticRenderFns } from "./ArtworkGrid.vue?vue&type=template&id=17934e2a&scoped=true"
import script from "./ArtworkGrid.vue?vue&type=script&lang=js"
export * from "./ArtworkGrid.vue?vue&type=script&lang=js"
import style0 from "./ArtworkGrid.vue?vue&type=style&index=0&id=17934e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17934e2a",
  null
  
)

export default component.exports